import { useOutletContext } from "react-router-dom";
import { EventsListPage } from "@/pages/events/index";
import UniversityNotFoundErrorBoundary from "../_components/UniversityNotFoundErrorBoundary";
import type { UniversityEventsOutletContext } from "./_layout";

export default function UniversityEventsPage() {
  const { universityId } = useOutletContext<UniversityEventsOutletContext>() ?? {};

  if (!universityId) {
    return <UniversityNotFoundErrorBoundary />;
  }

  return <EventsListPage embeddedUniversityId={universityId} />;
}
